<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
      <el-form-item label="区块链代码" prop="chainCode">
        <el-input v-model="dataForm.chainCode" placeholder="区块链代码"></el-input>
      </el-form-item>
      <el-form-item label="区块链名称" prop="chainName">
        <el-input v-model="dataForm.chainName" placeholder="区块链名称"></el-input>
      </el-form-item>
      <el-form-item label="英文名称" prop="chainNameEn">
        <el-input v-model="dataForm.chainNameEn" placeholder="英文名称"></el-input>
      </el-form-item>
      <el-form-item label="图标URL">
        <el-input v-model="dataForm.iconUrl" placeholder="图标URL(可选)"></el-input>
      </el-form-item>
      <el-form-item label="浏览器URL" prop="explorerUrl">
        <el-input v-model="dataForm.explorerUrl" placeholder="区块链浏览器URL"></el-input>
      </el-form-item>
      <el-form-item label="API地址" prop="rpcUrl">
        <el-input v-model="dataForm.rpcUrl" placeholder="RPC API地址"></el-input>
      </el-form-item>
      <el-form-item label="TRON-PRO-API-KEY">
        <el-input v-model="dataForm.ext1" placeholder="TronGrid API密钥(可选)"></el-input>
      </el-form-item>
      <el-form-item label="地址正则" prop="addressPattern">
        <el-input v-model="dataForm.addressPattern" placeholder="钱包地址正则表达式"></el-input>
      </el-form-item>
      <el-form-item label="启用状态">
        <el-switch v-model="dataForm.isEnabled" :active-value="1" :inactive-value="2"></el-switch>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        chainCode: '',
        chainName: '',
        chainNameEn: '',
        iconUrl: '',
        explorerUrl: '',
        rpcUrl: '',
        ext1: '',
        addressPattern: '',
        isEnabled: 1
      }
    }
  },
  computed: {
    dataRule () {
      return {
        chainCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        chainName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        chainNameEn: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        explorerUrl: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        rpcUrl: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        addressPattern: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/crypto/chain/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/crypto/chain', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
